import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "file",
  "use": "file-usage",
  "viewBox": "0 0 36 36",
  "content": "<symbol viewBox=\"0 0 36 36\" xmlns=\"http://www.w3.org/2000/svg\" id=\"file\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M10 8C10 7.72386 10.2239 7.5 10.5 7.5H19C19.139 7.5 19.2718 7.55789 19.3664 7.65977L25.8664 14.6598C25.9523 14.7523 26 14.8738 26 15V28C26 28.2761 25.7761 28.5 25.5 28.5H10.5C10.2239 28.5 10 28.2761 10 28V8ZM11 8.5V27.5H25V15.5H19C18.7239 15.5 18.5 15.2761 18.5 15V8.5H11ZM19.5 9.27327L24.3534 14.5H19.5V9.27327Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol